/**
 * Permission utilities for admin panel.
 * Uses slugs from PERMISSIONS_MANIFEST (e.g. consumers.customers_list.view, products.list.detail.write).
 * Super-admin has *:* (full access).
 */

const SUPER_ADMIN = '*:*';

/**
 * Check if user has a specific permission.
 * @param {string[]} permissions - User's permissions (from user.permissions or roleRef.permissions)
 * @param {string} slug - Permission slug (e.g. 'dashboard', 'consumers.customers_list.view')
 * @returns {boolean}
 */
export function hasPermission(permissions, slug) {
  if (!Array.isArray(permissions)) return false;
  if (permissions.includes(SUPER_ADMIN)) return true;
  return permissions.includes(slug);
}

/**
 * Check if user has write permission for a resource.
 * Checks both the specific .write slug and *:* .
 * @param {string[]} permissions
 * @param {string} writeSlug - e.g. 'consumers.customers_list.detail.write'
 * @returns {boolean}
 */
export function hasWritePermission(permissions, writeSlug) {
  return hasPermission(permissions, writeSlug);
}

/**
 * Check if user can create - uses .create or .write slug.
 * @param {string[]} permissions
 * @param {string} createSlug - e.g. 'products.list.create'
 * @returns {boolean}
 */
export function hasCreatePermission(permissions, createSlug) {
  return hasPermission(permissions, createSlug);
}

/**
 * Check if user can delete.
 * @param {string[]} permissions
 * @param {string} deleteSlug - e.g. 'products.list.detail.delete'
 * @returns {boolean}
 */
export function hasDeletePermission(permissions, deleteSlug) {
  return hasPermission(permissions, deleteSlug);
}
